// Navbar.jsx
import React, { useState } from 'react';
import logo1 from '../Assets/Assest/logo1.png';
import SearchCandidates from "./SearchCandidates";
import JobPost from "./JobPost";
import RightNav from './RightNav';
import { FaArrowLeft } from "react-icons/fa";
const Navbar = () => {
    const [hoveredDropdown, setHoveredDropdown] = useState(null);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [openDropdown, setOpenDropdown] = useState(null);
    const [isJobPostOpen, setIsJobPostOpen] = useState(false);
    const [isSearchCandidatesOpen, setIsSearchCandidatesOpen] = useState(false);

    const handleToggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
    };

    const toggleDropdown = (menu) => {
        setOpenDropdown(openDropdown === menu ? null : menu);
    };

    const handleMouseEnter = (menu) => {
        setHoveredDropdown(menu);
    };

    const handleMouseLeave = () => {
        setHoveredDropdown(null);
    };

    const handleToggleJobPost = () => {
        setIsJobPostOpen(!isJobPostOpen);
        setIsSearchCandidatesOpen(false); // Ensure other pages is closed
    };

    const handleToggleSearchCandidates = () => {
        setIsSearchCandidatesOpen(!isSearchCandidatesOpen);
        setIsJobPostOpen(false); // Ensure other page is closed
    };

    return (
        <div>
            {/* Main Navbar */}
            {!isJobPostOpen && !isSearchCandidatesOpen && (
                <nav className="bg-[#0077B5] text-white p-4 custom-navbar">
                    <div className="max-w-7xl mx-auto flex justify-between items-center px-0 sm:px-5 lg:px-7">
                        {/* Logo */}
                        <img
                            src={logo1}
                            alt="Company Logo"
                            className="h-12 sm:h-16 w-auto ml-0 sm:ml-[-4rem] lg:ml-[-8rem]"
                            style={{ marginLeft: 'calc(-2rem)' }}
                        />

                        {/* Desktop Menu */}
                        <div className="hidden md:flex space-x-6 ml-4 items-center">
                            {/* Jobs Posting */}
                            <div
                                className="relative"
                                onMouseEnter={() => handleMouseEnter('jobPost')}
                                onMouseLeave={handleMouseLeave}
                            >
                                <button className="hover:bg-#0077B5-700 py-2 px-4 rounded">
                                    Jobs Posting
                                </button>
                                {hoveredDropdown === 'jobPost' && (
                                    <div className="absolute top-full mt-px w-56 bg-white text-black shadow-lg rounded-lg custom-dropdown">
                                        <button
                                            onClick={handleToggleJobPost}
                                            className="block w-full text-left py-2 px-4 hover:bg-gray-200"
                                        >
                                            Post a Job
                                        </button>
                                        <button
                                            onClick={handleToggleJobPost}
                                            className="block w-full text-left py-2 px-4 hover:bg-gray-200"
                                        >
                                            Manage Job Posting
                                        </button>
                                    </div>
                                )}
                            </div>

                            {/* Resume Search */}
                            <div
                                className="relative"
                                onMouseEnter={() => handleMouseEnter('resume')}
                                onMouseLeave={handleMouseLeave}
                            >
                                <button className="hover:bg-#0077B5-700 py-2 px-4 rounded">
                                    Resume Search
                                </button>
                                {hoveredDropdown === 'resume' && (
                                    <div className="absolute top-full mt-px w-48 bg-white text-black shadow-lg rounded-lg">
                                        <button
                                            onClick={handleToggleSearchCandidates}
                                            className="block w-full text-left py-2 px-4 hover:bg-gray-200"
                                        >
                                            Featured Search
                                        </button>
                                        <button
                                            onClick={handleToggleSearchCandidates}
                                            className="block w-full text-left py-2 px-4 hover:bg-gray-200"
                                        >
                                            Advanced Search
                                        </button>
                                    </div>
                                )}
                            </div>
                            {/* search bar */}
                            <div className="flex space-x-2 items-center mr-10">
                                <input
                                    type="text"
                                    placeholder="Search..."
                                    className="w-full px-2 py-2 text-black bg-gray-100 rounded-lg"
                                />
                               <RightNav></RightNav>
                            </div>
                        </div>

                        {/* Hamburger Menu */}
                        <button
                            className="md:hidden focus:outline-none"
                            onClick={handleToggleMobileMenu}
                        >
                            <svg
                                className="w-8 h-8 text-white"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                    d="M4 6h16M4 12h16m-7 6h7"
                                />
                            </svg>
                        </button>
                    </div>
                </nav>
            )}

            {/* Job Post Page */}
            {isJobPostOpen && (
                <div className="absolute inset-0 z-20 bg-white p-6">
                    <button
                        onClick={handleToggleJobPost}
                        className="absolute top-32 left-7 text-blue-500 hover:underline flex items-center"
                    >
                         <FaArrowLeft className="mr-2" />
                    </button>
                    <JobPost />
                </div>
            )}

            {/* Search Candidates Page */}
            {isSearchCandidatesOpen && (
                <div className="absolute inset-0 z-20 bg-white p-6">
                    <button
                        onClick={handleToggleSearchCandidates}
                        className="absolute top-36 left-7 text-blue-500 hover:underline flex items-center justify-between"
                    >
                        <FaArrowLeft className="mr-2" />
                    
                    </button>
                    <SearchCandidates />
                </div>
            )}
        </div>
    );
};

export default Navbar;
